export { type WordBiau, wordBiauTable } from "#word-biau-table";
